var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCareTeamMessageIcon = function SvgCareTeamMessageIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.357 11.4159C17.5617 11.4148 15.0163 13.0873 13.8197 15.7111C12.6232 18.3349 12.9901 21.4401 14.7618 23.6856C14.4281 24.9796 13.9943 25.9558 13.6161 26.2678C13.4718 26.3573 13.3689 26.504 13.3312 26.6741C13.2934 26.8441 13.324 27.0228 13.4159 27.169C13.5547 27.334 13.7623 27.4181 13.9721 27.3942C15.0288 27.3942 17.0811 26.3313 17.7819 25.9443C20.4908 27.015 23.5536 26.302 25.5634 24.1327C27.5731 21.9635 28.1414 18.7573 27.0072 15.9869C25.873 13.2166 23.2555 11.4174 20.357 11.4159Z",
    fill: "#3D8AF7"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCareTeamMessageIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/care-team-message-icon.2638e8a1ed7e06a4f803b0ef236550ec.svg";